export const PaymentType = Object.freeze({
  KEKS10: 'KEKS10',
  TELEGRAM20: 'TELEGRAM20',
  POPUST20: 'POPUST20',
  Popust40: 'Popust40',
  Popust50: 'Popust50',
  FREE: 'FREE',
  CASH20: 'CASH20',
  CARD20: 'CARD20',
  CASH50: 'CASH50',
  CARD50: 'CARD50',
})
